var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cb cb--all"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selected},on:{"change":function($event){return _vm.handleChange($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }